import { Component } from '@angular/core';
import { MobileZoomService } from './mobile-zoom.service';

/**
 * スマホだけに出す、右端に常に出る拡大「＋」・縮小「－」（PC では何も出ない）
 * position: fixed なので置く場所はどこでもよい。ダイアログを開いている間も押せる
 *
 * 使い方：<app-mobile-zoom></app-mobile-zoom> を画面のテンプレートに置く
 */
@Component({
  selector: 'app-mobile-zoom',
  templateUrl: './mobile-zoom.component.html',
  styleUrls: ['./mobile-zoom.component.less']
})
export class MobileZoomComponent {

  constructor(public mz: MobileZoomService) { }
}
